import { useBreadcrumb } from '../hooks/useBreadcrumb';

type TermProps = {
	children: string;
};

const Term = ({ children }: TermProps) => {
	const { blockClass } = useBreadcrumb();

	const renderClass = () => {
		return blockClass && `term--${blockClass} vtex-breadcrumb-1-x-term--${blockClass}`;
	};

	return <span className={`term vtex-breadcrumb-1-x-term ph2 c-on-base ${renderClass()}`}>{children}</span>;
};

export default Term;
